import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { LoaderButton } from ".";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import { renderEyeTest } from "./renderEyeTest";
import { Error } from "components/input";

const renderIndigenous = (value) => {
  if (value === "yes") return "Yes";
  else if (value === "no") return "No";
  else if (value === "prefer_not_to_say") return "Prefer not to say";
  else return "";
};

export default class PatientEnrolmentConfirm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      serverError: false,
      isLoading: false,
      values: props.values,
      errors: {},
    };
  }

  handleClick = async () => {
    if (!this.validRecaptcha()) {
      return;
    }

    const query_params = JSON.stringify(
      Object.fromEntries(new URLSearchParams(location.search))
    );

    let response;
    const { csrfToken, navigate } = this.props;
    const config = { headers: { "X-CSRF-TOKEN": csrfToken } };
    const params = {
      enrolment: {
        ...this.state.values,
        query_params,
      },
    };

    try {
      this.setState({ isLoading: true });
      response = await axios.post("/patient_enrolments", params, config);
    } catch (e) {
      this.setState({ isLoading: false, serverError: true });
      return;
    }

    if (this.isBookEyeCheck()) {
      navigate(this.bookEyeCheckPath(response), { replace: false });
    } else {
      document.location = "/patient_enrolments/success";
    }
  };

  bookEyeCheckPath = ({
    data: { patient_enrolment_uuid: patientEnrolmentUuid },
  }) => {
    const {
      first_name,
      surname,
      title,
      ndss,
      last_eye_test,
      follow_up_email_address,
    } = this.state.values;

    const patientName = `${title} ${first_name} ${surname}`;
    const lastEyeCheck = renderEyeTest(last_eye_test);

    return `/patient_enrolments/book_eye_check?&patientName=${patientName}&ndssNumber=${ndss}&lastEyeCheck=${lastEyeCheck}&email=${follow_up_email_address}&patientEnrolmentUuid=${patientEnrolmentUuid}`;
  };

  isBookEyeCheck = () => {
    const { last_eye_test, indigenous } = this.state.values;

    // this logic doesnt look right. double check
    return (
      (indigenous === "yes" && last_eye_test === "1_2_years") ||
      last_eye_test === "unknown_never" ||
      last_eye_test === "over_2_years"
    );
  };

  renderSMSPreference = () => {
    if (!this.state.values.follow_up_sms) {
      return "";
    } else {
      return (
        <span>
          SMS: {this.state.values.follow_up_sms_number}
          <br />
        </span>
      );
    }
  };

  renderEmailPreference = () => {
    if (!this.state.values.follow_up_email) {
      return "";
    } else {
      return (
        <span>
          Email: {this.state.values.follow_up_email_address}
          <br />
        </span>
      );
    }
  };

  renderPostPreference = () => {
    if (!this.state.values.follow_up_post) {
      return "";
    } else {
      return (
        <span>
          Post: {this.state.values.follow_up_post_address}
          <br />
        </span>
      );
    }
  };

  renderCommunicationPreference = () => {
    return (
      <div className="key-value-value" id="communication_preference">
        {this.renderSMSPreference()}
        {this.renderEmailPreference()}
        {this.renderPostPreference()}
      </div>
    );
  };

  setRecaptchaValue = (value) => {
    const { values, errors } = this.state;
    errors.recaptcha_token = null;
    values.recaptcha_token = value;
    this.setState({ errors, values });
  };

  validRecaptcha = () => {
    const { values, errors } = this.state;

    if (values.recaptcha_token === null) {
      errors.recaptcha_token = "required";
      this.setState({ errors });
      return false;
    }

    return true;
  };

  render() {
    let errorMessage = "";
    if (this.state.serverError === true) {
      errorMessage = (
        <div>Something unexpected happened. Failed to submit enrolment.</div>
      );
    }

    return (
      <div className="mdc-layout-grid max-width">
        <h2>Confirm your details</h2>

        {errorMessage}

        <div className="mdc-layout-grid__inner">
          <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-6">
            <div className="mdc-layout-grid__inner">
              <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
                <div className="key-value-wrapper">
                  <div className="key-value">
                    <div className="key-value-key">Name</div>
                    <div className="key-value-value" id="name">
                      {this.state.values.title} {this.state.values.first_name}{" "}
                      {this.state.values.surname}
                    </div>
                  </div>

                  <div className="key-value">
                    <div className="key-value-key">Date of Birth</div>
                    <div className="key-value-value" id="dob">
                      {this.state.values.dob}
                    </div>
                  </div>

                  <div className="key-value">
                    <div className="key-value-key">Postcode</div>
                    <div className="key-value-value" id="postcode">
                      {this.state.values.postcode}
                    </div>
                  </div>

                  <div className="key-value">
                    <div className="key-value-key">Indigenous</div>
                    <div className="key-value-value" id="indigenous">
                      {renderIndigenous(this.state.values.indigenous)}
                    </div>
                  </div>

                  <div className="key-value">
                    <div className="key-value-key">NDSS</div>
                    <div className="key-value-value" id="ndss">
                      {this.state.values.ndss || "Not supplied"}
                    </div>
                  </div>

                  <div className="key-value">
                    <div className="key-value-key">HbA1c</div>
                    <div className="key-value-value" id="hba1c">
                      {this.state.values.hba1c || "Unknown"}
                    </div>
                  </div>

                  <div className="key-value">
                    <div className="key-value-key">Last Eye Test</div>
                    <div className="key-value-value" id="last_eye_test">
                      {renderEyeTest(this.state.values.last_eye_test)}
                    </div>
                  </div>

                  <div className="key-value">
                    <div className="key-value-key">
                      Communication preference
                    </div>
                    <div className="key-value-value">
                      {this.renderCommunicationPreference()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mdc-layout-grid__inner">
          <div
            id="recaptcha_form_group"
            className={
              "form-group " +
              (!!this.state.errors.recaptcha_token && "field_with_errors")
            }
          >
            <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 mdc-layout-grid__cell--span-8-phone mdc-layout-grid__cell--span-4-phone">
              <div className="mdc-form-field">
                <ReCAPTCHA
                  sitekey={process.env.RECAPTCHA_SITE_KEY}
                  onChange={(response) => {
                    this.setRecaptchaValue(response);
                  }}
                />
              </div>
              {this.state.errors.recaptcha_token && (
                <Error errorText={this.state.errors.recaptcha_token} />
              )}
            </div>
          </div>
        </div>

        <div className="mdc-layout-grid__inner">
          <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-2">
            <LoaderButton
              id="submit_enrolment_btn"
              className="primary-button"
              variant="primary"
              size="lg"
              isLoading={this.state.isLoading}
              text="Submit"
              loadingText="Sending…"
              onClick={this.handleClick}
            />
          </div>
          <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-3">
            <Button
              variant="primary"
              className="secondary-button"
              size="lg"
              onClick={this.props.previousPage}
            >
              Go back
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
